// fetching parameters from the URL

class GetUrlQueries {

  static urlQueries(query) {
    Object.keys(query).forEach(key => query[key] === undefined ? delete query[key] : '');
    Object.keys(query).forEach(key => key === 'filters' ? delete query[key] : '');

    return '/?' +
      Object.keys(query).map(function(key) {
          return encodeURIComponent(key) + '=' +
              encodeURIComponent(query[key]);
      }).join('&');
  }

}

export default GetUrlQueries



// WEBPACK FOOTER //
// ./src/classes/GetUrlQueries.js